import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, money } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/products?include_inactive=true").then(({ data }) => setProducts(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.put(`/products/${edit.id}`, {
        ...edit,
        retail_price: parseFloat(edit.retail_price),
        wholesale_price: edit.wholesale_price === "" || edit.wholesale_price == null ? null : parseFloat(edit.wholesale_price),
        suggested_gym_retail: edit.suggested_gym_retail == null || edit.suggested_gym_retail === "" ? null : parseFloat(edit.suggested_gym_retail),
        production_cost: edit.production_cost == null || edit.production_cost === "" ? null : parseFloat(edit.production_cost),
        moq: parseInt(edit.moq || 0, 10),
        weight_oz: edit.weight_oz == null || edit.weight_oz === "" ? null : parseFloat(edit.weight_oz),
      });
      toast.success("Product saved");
      setEdit(null);
      load();
    } catch { toast.error("Save failed"); }
  };

  const setField = (k) => (e) => setEdit((p) => ({ ...p, [k]: e.target.value }));

  return (
    <div className="px-5 lg:px-8 py-8">
      <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">Catalog</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1 mb-6">Products</h1>

      <div className="bg-[#121216] border border-white/10 rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
              <th className="px-4 py-3">Product</th><th className="px-4 py-3">Category</th><th className="px-4 py-3">Retail</th>
              <th className="px-4 py-3">Wholesale</th><th className="px-4 py-3">Prod. Cost</th><th className="px-4 py-3">MOQ</th><th className="px-4 py-3">Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id} className="border-b border-white/5 hover:bg-white/5">
                <td className="px-4 py-3 text-white">{p.name}<span className="block text-[10px] font-mono text-zinc-600">{p.audience}{p.extended_size_rule ? " · ext sizes" : ""}</span></td>
                <td className="px-4 py-3 text-zinc-400">{p.category}</td>
                <td className="px-4 py-3 font-mono text-yellow-400">{money(p.retail_price)}</td>
                <td className="px-4 py-3 font-mono text-emerald-400">{p.wholesale_price != null ? money(p.wholesale_price) : "—"}</td>
                <td className="px-4 py-3 font-mono text-zinc-400">{p.production_cost != null ? money(p.production_cost) : "—"}</td>
                <td className="px-4 py-3 font-mono">{p.moq || 0}</td>
                <td className="px-4 py-3"><span className={p.status === "active" ? "text-emerald-400" : "text-zinc-600"}>{p.status}</span></td>
                <td className="px-4 py-3"><button data-testid={`edit-product-${p.id}`} onClick={() => setEdit(p)} className="text-yellow-400 font-mono text-xs uppercase">Edit</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent className="bg-[#121216] border-white/15 text-white max-w-lg">
          <DialogHeader><DialogTitle className="font-heading uppercase">{edit?.name}</DialogTitle></DialogHeader>
          {edit && (
            <div className="grid grid-cols-2 gap-4">
              <div><Label className="text-zinc-400">Retail Price</Label><Input data-testid="edit-retail" value={edit.retail_price} onChange={setField("retail_price")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">Wholesale Price</Label><Input data-testid="edit-wholesale" value={edit.wholesale_price ?? ""} onChange={setField("wholesale_price")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">Suggested Gym Retail</Label><Input value={edit.suggested_gym_retail ?? ""} onChange={setField("suggested_gym_retail")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">Production Cost</Label><Input value={edit.production_cost ?? ""} onChange={setField("production_cost")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">MOQ</Label><Input value={edit.moq ?? 0} onChange={setField("moq")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">Packed Weight (oz)</Label><Input data-testid="edit-weight" value={edit.weight_oz ?? ""} onChange={setField("weight_oz")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <div><Label className="text-zinc-400">Status</Label>
                <select value={edit.status} onChange={setField("status")} className="w-full bg-[#0A0A0C] border border-white/15 rounded px-2 py-2 mt-1 text-sm">
                  <option value="active">active</option><option value="inactive">inactive</option>
                </select>
              </div>
              <div className="col-span-2"><Label className="text-zinc-400">Description</Label><Input value={edit.description || ""} onChange={setField("description")} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
              <button data-testid="save-product" onClick={save} className="btn-primary col-span-2 px-6 py-3 rounded-sm mt-2">Save Product</button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
